module.exports = __webpack_public_path__ + "images/b2352f11fcddeafe9625f0248cab17ae.jpg";